import Message from "@intility/bifrost-react/Message";
import type { ReactNode } from "react";
import { useIsProviderAdmin } from "./capabilities";

/**
 * Route guard: renders children only for an admin on provider:intility (Intility IAM).
 * Fails closed (renders nothing) until the check resolves, like RequireCapability.
 */
export default function RequireProviderAdmin({
  children,
}: {
  children: ReactNode;
}) {
  const { isProviderAdmin, isLoading } = useIsProviderAdmin();

  if (isLoading) return null;

  if (!isProviderAdmin) {
    return (
      <div className="bf-content bfl-page-padding">
        <Message state="warning" header="No access">
          You don't have access to this page. It needs admin on
          provider:intility (Intility IAM).
        </Message>
      </div>
    );
  }

  return <>{children}</>;
}
